<template>
  <div>
    <h3>客户管理</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="手机号">
        <el-input
          placeholder="输入用户手机号"
          v-model="filter.phoneNumber"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input
          placeholder="输入用户昵称"
          v-model="filter.nickname"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户id">
        <el-input
          placeholder="输入用户id"
          v-model.number="filter.userId"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户级别">
        <el-select
          v-model="filter.customerLevel"
          :clearable="true"
          placeholder="请选择客户级别"
        >
          <el-option
            v-for="(item, key) in map.user.customerLevel"
            :key="key"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户类型">
        <el-select
          v-model="filter.type"
          :clearable="true"
          placeholder="请选择客户类型"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(item, key) in map.user.type"
            :key="key"
            :label="item"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户分类">
        <el-select
          v-model="filter.clientType"
          :clearable="true"
          placeholder="请选择客户级别"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(item, key) in map.client.type"
            :key="key"
            :label="item"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进状态">
        <el-select
          v-model="filter.followStatus"
          :clearable="true"
          placeholder="请选择跟进状态"
        >
          <el-option
            v-for="(item, key) in map.client.followStatus"
            :key="key"
            :label="item"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间从">
        <el-date-picker
          v-model="filter.createTimeStart"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.createTimeEnd"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="下次跟进时间从">
        <el-date-picker
          v-model="filter.nextFollowTimeStart"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.nextFollowTimeEnd"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="跟进人">
        <el-input placeholder="输入跟进人" v-model="filter.founder"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" size="mini" @click="exportExcel"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="userId" label="用户id"></el-table-column>
      <el-table-column prop="nickname" label="用户昵称"></el-table-column>
      <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
      <el-table-column prop="companyName" label="企业名称"></el-table-column>
      <el-table-column prop="jobNum" label="职位数">
        <template slot-scope="scope">
          <a :href="`/jobs?publisherId=${scope.row.userId}`" target="_blank">{{
            scope.row.jobNum
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="订单数">
        <template slot-scope="scope">
          <a
            :href="`/orders?publisherId=${scope.row.userId}`"
            target="_blank"
            >{{ scope.row.orderNum }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="timingOrderNum"
        label="计时订单数"
      ></el-table-column>
      <el-table-column prop="taskInfoNum" label="任务数"></el-table-column>
      <el-table-column prop="taskOrderNum" label="任务订单数"></el-table-column>
      <el-table-column
        prop="totalDepositAmount"
        label="累计预付金额"
      ></el-table-column>
      <el-table-column
        prop="unfinishedOrder"
        label="进行中订单数"
      ></el-table-column>
      <el-table-column prop="createTime" label="注册时间"></el-table-column>
      <el-table-column prop="clientType" label="客户分类">
        <template slot-scope="scope">{{
          map.client.type[scope.row.clientType]
        }}</template>
      </el-table-column>
      <el-table-column prop="followStatus" label="跟进状态">
        <template slot-scope="scope">{{
          map.client.followStatus[scope.row.followStatus]
        }}</template>
      </el-table-column>
      <el-table-column prop="lastFollower" label="跟进人"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-dropdown size="medium">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a
                  :href="`/sessions?senderId=${scope.row.userId}`"
                  target="_blank"
                  >查询沟通记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <a :href="`/follows?userId=${scope.row.userId}`" target="_blank"
                  >查看跟进记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <a
                  :href="`/follow/detail?userId=${scope.row.userId}&from=clients`"
                  target="_blank"
                  >添加跟进记录</a
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <!-- <a
                  :href="`/user-detail?userId=${scope.row.userId}`"
                  target="_blank"
                  >查看认证信息</a
                > -->
                <a
                  :href="`/user-detail?userId=${scope.row.aesUserId}`"
                  target="_blank"
                  >查看认证信息</a
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";

import api from "../api";
let { client } = api;
export default {
  name: "clientList",
  data() {
    return {
      map,
      filter: {
        userId: "",
        nickname: "",
        customerLevel: "",
        createTimeStart: "",
        createTimeEnd: "",
        nextFollowTimeStart: "",
        nextFollowTimeEnd: "",
        phoneNumber: "",
        followStatus: "",
        founder: "",
        clientType: "",
        type: "",
      },
      loading: true,
      list: [],
      total: 0,
      pageNum: 1,
      limit: 20,
    };
  },
  computed: {
    uid() {
      return this.$route.query.uid;
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {
    if (this.uid) {
      this.filter.userId = Number(this.uid);
    }
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let {
        userId,
        nickname,
        customerLevel,
        createTimeStart,
        createTimeEnd,
        nextFollowTimeStart,
        nextFollowTimeEnd,
        phoneNumber,
        followStatus,
        founder,
        clientType,
        type,
      } = this.filter;
      this.loading = true;
      let {
        data: { data, code, desc, pageinfo },
      } = await client.clients({
        pageNum: this.pageNum,
        limit: this.limit,
        userId: Number.isInteger(userId) ? userId : "",
        nickname,
        customerLevel,
        createTimeStart,
        createTimeEnd,
        nextFollowTimeStart,
        nextFollowTimeEnd,
        phoneNumber,
        followStatus,
        founder,
        clientType,
        type,
      });
      if (code == 200) {
        this.list = data;
        this.total = pageinfo.totalCount;
      }
      this.loading = false;
    },
    async exportExcel() {
      this.loading = true;
      let resp = await client.export();
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("客户列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/client/clients.vue